import { Plus } from 'lucide-react';
import { CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

/**
 * A job form section's heading: icon, title, an optional line under it, and
 * its add button on the right.
 *
 * On a phone the button says just "Add": "Add Hidden Cost" beside "Hidden
 * costs" left the title two words wide and wrapping. The full label stays
 * on wider screens and is always the button's accessible name.
 *
 *   action    { label, onClick, icon, testId } for an add button, or
 *   children  anything else for the right-hand side (the crew picker)
 */
export function FormSectionHeader({ icon: Icon, iconClassName, title, subtitle, action, children, className }) {
  const ActionIcon = action?.icon || Plus;
  return (
    <CardHeader className={cn('flex flex-row items-center justify-between gap-3 space-y-0 max-sm:p-4', className)}>
      <div className="min-w-0">
        <CardTitle className="flex items-center gap-2 max-sm:text-xl">
          {Icon && <Icon className={cn('w-5 h-5 shrink-0', iconClassName)} />}
          <span className="truncate">{title}</span>
        </CardTitle>
        {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={action.onClick}
          aria-label={action.label}
          className="shrink-0"
          data-testid={action.testId}
        >
          <ActionIcon className="w-4 h-4" />
          <span className="sm:hidden">Add</span>
          <span className="hidden sm:inline">{action.label}</span>
        </Button>
      )}
      {children}
    </CardHeader>
  );
}
